import { ActionIcon, Flex, Loader, Stack, Text, TextInput, Title } from '@mantine/core';
import React from 'react';
import Button from '../../components/elements/Button';
import IconSearch from '../../components/icons/IconSearch';
import IconClose from '../../components/icons/IconClose';
import styles from './styles.scoped.css';
import IconError from '../../components/icons/IconError';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { clearRedux } from './actions';

const FormSearch = ({
  search = '',
  setSearch = () => {},
  handleSearch,
  data = {},
  title = 'Cari data Subpangkalan',
  subtitle = 'Masukkan ID Subpangkalan untuk mencari data Subpangkalan',
  placeholder = 'Masukkan ID Registrasi / ID Subpangkalan untuk mencari...',
  btnSearchText = 'Cari Subpangkalan'
}) => {
  const dispatch = useDispatch();
  return (
    <Flex gap="md">
      <img
        height="100"
        src="/assets/illu-setting-merchant.svg"
        width="100"
      />
      <Stack>
        <div>
          <Title order={4}>{title}</Title>
          <Text c="#52575C" fz={18}>{subtitle}</Text>
        </div>
        <TextInput classNames={{
          error: 'errorInput'
        }} error={data?.code === 404 && <Flex align="center" gap="xs">
          <span><IconError/></span>
          <Text c="#CF212A" fz="sm">Subpangkalan tidak ditemukan, pastikan ID yang Anda masukkan benar</Text>
        </Flex>} onChange={({ currentTarget: { value } }) => {
          setSearch(value);
          if(data?.code === 404 || data?.code === 400){
            dispatch(clearRedux('search'));
          }
        }} placeholder={placeholder} rightSection={search.length > 0 ? <ActionIcon bg="transparent" onClick={() => setSearch('')}>
          <IconClose className={styles.iconClose}/>
        </ActionIcon>: null} styles={{
          root: {
            '[data-invalid]':{
              '::placeholder': {
                color: '#CF212A !important'
              },
              borderColor: '#CF212A'
            }
          }
        }} value={search} />
        <Button disabled={data?.loading} onClick={handleSearch}>
          <Flex align="center" gap="xs" justify="center">
            {data?.loading ? <Loader color="white" size="xs"/> : <IconSearch/>} {btnSearchText}
          </Flex>
        </Button>
      </Stack>
    </Flex>
  );
};

export default FormSearch;

FormSearch.propTypes = {
  btnSearchText: PropTypes.string,
  data: PropTypes.object,
  handleSearch: PropTypes.func,
  placeholder: PropTypes.string,
  search: PropTypes.string,
  setSearch: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string
};
